export default "__VITE_ASSET__DkAu8iT5__"